const stripProhibitedCharactersOnSubmit = (input) => {
    var filteredValues = "<>{#\`~$\&^+=<>\"|\\%}",
        filteredStrings = ["\\S*alert\\S*", "\\S*Alert\\S*", "\\S*Prompt\\S*", "\\S*prompt\\S*", "\\S*javascript\\S*", "\\S*Script\\S*", "\\S*script\\S*", "\\S*document\\.write\\(\\S*", "\\S*document\\.execCommand\\(\\S*", "\\S*confirm\\(\\S*", "\\S*eval\\(\\S*"],
        result = "",
        x;

    if (input.length > 0) {
        for (x = 0; x < filteredStrings.length; x++) {
            var regex = new RegExp(filteredStrings[x], "g");
            input = input.replace(regex, " ");
        }
    }

    for (x = 0; x < input.length; x++) {
        var currentChar = input.charAt(x).replace("/", "-");
        if (filteredValues.indexOf(currentChar) === -1) result += currentChar;
    }

    return result;
};

export {stripProhibitedCharactersOnSubmit}
